module.exports = __webpack_public_path__ + "static/media/image.458a0884.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/elements/image.svg
// module id = 282
// module chunks = 1